import { appConfig } from '@common/config';
import { DETAIL_STATE } from '@constants/common';
import { toastOption } from '@hook/useErrorToastMessage';
import { useSetSearchParams } from '@hook/useSetSearchParams';
import useShare from '@hook/useShare';
import { type IDetailIndexPorps, type IDetailItemInfo } from '@interface/IDetail';
import { itemInfoQueryKey } from '@network/queryKeys';
import { useDataQuery } from '@network/querys';
import { keepPreviousData } from '@tanstack/react-query';
import { useEffect } from 'react';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

export const Title = ({ props }: { props: IDetailIndexPorps }) => {
    const { t } = useTranslation();
    const setParams = useSetSearchParams();
    const { startShare } = useShare();

    const queryParams = appConfig.service !== 'bnsneo' ? { enchantLevel: props.detailEnchant } : { level: props.detailLevel };

    const { data: iteminfo } = useDataQuery<IDetailItemInfo>(
        itemInfoQueryKey,
        `/${appConfig.service}/v2.0/game/item/${props.detailId}`,
        queryParams,
        {
            staleTime: 5000,
            placeholderData: keepPreviousData,
            enabled: props.detailNow === DETAIL_STATE.ITEM && !!props.detailId,
        }
    );

    useEffect(() => {}, [iteminfo]);

    const onShare = () => {
        startShare({
            _apiPath: `${appConfig.apiDomain}/${appConfig.service}/v2.0/game/short`,
            _title: `${iteminfo?.enchantLevel ? `+${iteminfo?.enchantLevel} ` : ''}${iteminfo?.itemName}`,
            _callback: () => {
                toast.dismiss();
                toast(
                    (to) => (
                        <div className="toast-wrapper">
                            <span className="toast-title">{t('common.copiedurl')}</span>
                        </div>
                    ),
                    toastOption
                );
            },
        });
    };

    return (
        <div className="gameinfo-detail__title">
            <button className="btn-prev" onClick={() => {
                const checkUrlAfterBack = () => {
                    // URL에 detail 파라미터가 없으면 상세 레이어를 닫음
                    if (!window.location.href.includes('?detail=')) {
                        setParams({ detail: '' });
                    }
                };

                // popstate 이벤트 리스너 추가
                window.addEventListener('popstate', checkUrlAfterBack, { once: true });

                // 뒤로가기 실행
                window.history.back();
            }}

            >
                Prev
            </button>
            <h2>{t('common.viewdetail')}</h2>
            <button className="btn-share" title={t('common.sharebtn')} data-areas="시세_아이템상세_공유_클릭" onClick={onShare} />
            <button
                className="btn-close"
                onClick={() => {
                    document.querySelector('.gameinfo-detail__section')?.scrollTo({ top: 0 });
                    setParams({ detail: '' });
                }}
            >
                close
            </button>
        </div>
    );
};
